export default __webpack_public_path__ + "static/media/confesiones2.1ce6555d.png";